export default {
  state: {
    access_token: null,
    refresh_token: null
  },
  mutations: {
    setToken(state, payload) {
      if (!payload) {
        state.access_token = null
        state.refresh_token = null
      } else {
        if (payload.access_token)
          state.access_token = payload.access_token
        if (payload.refresh_token)
          state.refresh_token = payload.refresh_token
      }
    }
  },
  actions: {
    setToken({commit}, payload) {
      commit('setToken', payload)
    },
    removeTokens({commit}) {
      commit('setToken', null)
    }
  },
  getters: {
    getToken(state) {
      return [state.access_token, state.refresh_token]
    }
  }
}
